import { createFileRoute } from "@tanstack/react-router";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export const Route = createFileRoute("/terms")({
  component: Terms,
});

function Terms() {
  return (
    <>
      <Header />
      <div className="legal-wrap">
        <main className="docs-content">
          <h1>Terms</h1>
          <p className="legal-date">Last updated: June 21, 2026</p>
          <p className="lead">
            The agreement between you and notify, in plain language. By using notify you accept these
            terms.
          </p>

          <h2>What notify provides</h2>
          <p>
            notify is hosted notification infrastructure. Today that’s native browser push: you embed a
            script, register devices, and send messages through our API. We’ll add channels (in-app,
            email, and more) over time; these terms cover those too as they ship.
          </p>

          <h2>Early access</h2>
          <p>
            notify is in early access. Features may change, break, or disappear, and delivery is not
            guaranteed. Use it at your own risk and don’t rely on it for safety-critical messages.
          </p>

          <h2>Acceptable use</h2>
          <ul>
            <li>Only send notifications to people who asked for them. No spam, no deceptive content.</li>
            <li>Don’t use notify to harass, mislead, defraud, or harm anyone, or to send unlawful content.</li>
            <li>Don’t probe, abuse, reverse-engineer, or bypass security controls or rate limits.</li>
            <li>
              You’re responsible for the <span className="icode">userId</span>s and content you send, for
              having consent to notify those users, and for honoring their opt-outs.
            </li>
          </ul>

          <h2>Your tokens</h2>
          <p>
            Anonymous tokens are provided as-is for evaluation. Claim a token for durable limits and
            support. Keep server-side tokens secret — you’re responsible for activity under your tokens,
            and we may revoke tokens involved in abuse.
          </p>

          <h2>Third-party services</h2>
          <p>
            Delivery depends on services we don’t control — browser push providers (Google, Mozilla,
            Apple, Microsoft), our infrastructure provider (Cloudflare), and our observability provider
            (Axiom). Their availability and terms apply, and we’re not responsible for their actions or
            outages.
          </p>

          <h2>Availability and changes</h2>
          <p>
            We provide the service on a best-effort basis and may modify, suspend, or discontinue any
            part of it at any time. We’ll try to give notice of significant changes.
          </p>

          <h2>No warranty</h2>
          <p>
            The service is provided “as is” and “as available,” without warranties of any kind, express
            or implied, including merchantability, fitness for a particular purpose, and guaranteed or
            timely delivery of any notification.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, notify is not liable for indirect, incidental, or
            consequential damages, lost profits, or lost data — including notifications that are delayed,
            duplicated, or never delivered.
          </p>

          <h2>Termination</h2>
          <p>
            We may suspend or terminate access for violations of these terms or where continued use poses
            a security or abuse risk. You can stop using notify at any time and delete your tokens.
          </p>

          <h2>Changes to these terms</h2>
          <p>We’ll post updates here with a new date. Continued use after a change means you accept it.</p>

          <h2>Contact</h2>
          <p>
            Reach us at{" "}
            <a className="ilink" href="mailto:contact@getnotify.dev">
              contact@getnotify.dev
            </a>
            .
          </p>
        </main>
      </div>
      <Footer />
    </>
  );
}
